import { TmrBaseResource } from 'stylewhere/api'

export class SortingGroupReads extends TmrBaseResource {
  static endpoint = 'api/v1/sortinggroupreads' //logistics/
}
